// extracted by mini-css-extract-plugin
export var container = "_lb-0";
export var dotAnimation = "_lb-2";
export var dotsLoading = "_lb-1";